export default "__VITE_ASSET__43f9431d__"